import { AuthView } from '@daveyplate/better-auth-ui';
import { Row, Card } from 'components/lib';

type ForgotPasswordProps = Record<string, never>;

export function ForgotPassword(_props: ForgotPasswordProps) {
  return (
    <Row title="" customClass="auth-form-row">
      <Card restrictWidth center extraClass="form-container forgot-password-form-container" isStat={true}>
        <AuthView
          view="FORGOT_PASSWORD"
          className="um-forgot-auth max-w-none border-0 bg-transparent !py-3 shadow-none gap-3"
          classNames={{
            form: {
              error: '!text-red-600 !text-[13px]',
              input: 'border-0 bg-white/35 placeholder:text-black/20',
              label: 'hidden',
              primaryButton: 'rounded-full border border-black bg-transparent text-current hover:bg-transparent',
            },
          }}
        />
      </Card>
    </Row>
  );
}
